import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class PagesService {

    constructor(private api: ApiService) {
    }

    getLocalizations() {
        return this.api.get(`/admin/localizations`).pipe(map(({result}) => result));
    }

    getPages(localeName = 'en-en') {
        return this.api.get(`/admin/pages/${localeName}`).pipe(map(({result}) => result.pages));
    }

    savePages(localeName = 'en-en', data) {
        return this.api.put(`/admin/pages/${localeName}`, data).pipe(map(({result}) => result.pages));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/pages.service.ts